import { graphql, useLazyLoadQuery } from 'react-relay';
import type { HomePageQuery } from '@/__generated__/HomePageQuery.graphql';

const homePageQuery = graphql`
  query HomePageQuery {
    viewer {
      id
      name
      email
      hello
    }
  }
`;

export function HomePage() {
  const data = useLazyLoadQuery<HomePageQuery>(homePageQuery, {});

  return (
    <main className="grid min-h-screen place-items-center bg-background p-6">
      <section className="w-full max-w-xl rounded-3xl border bg-card p-8 shadow-sm">
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-primary">
          Lisboon System
        </p>
        <h1 className="mt-4 text-4xl font-bold tracking-tight text-foreground">
          {data.viewer?.hello ?? 'Sem sessão'}
        </h1>
        <p className="mt-4 text-muted-foreground">
          Primeira tela consumindo o usuário de demonstração via GraphQL Relay.
        </p>
        <dl className="mt-8 grid gap-3 rounded-2xl bg-muted p-4 text-sm">
          <div className="flex justify-between gap-4">
            <dt className="text-muted-foreground">Nome</dt>
            <dd className="font-medium text-foreground">{data.viewer?.name ?? '—'}</dd>
          </div>
          <div className="flex justify-between gap-4">
            <dt className="text-muted-foreground">Email</dt>
            <dd className="font-medium text-foreground">{data.viewer?.email ?? '—'}</dd>
          </div>
        </dl>
      </section>
    </main>
  );
}
